import React, { useState, useEffect } from "react";
import RatingGame from "../../components/RatingGame";
import useGame from "../../hooks/useGame";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";

function GenerateUniqueRandom(min, max, notthisArray) {
    var returnMe = Math.floor(Math.random() * (max - min) + min);
    console.log(notthisArray)

    if (notthisArray.includes(returnMe)) {
        return GenerateUniqueRandom(min, max, notthisArray);
    }

    return returnMe;
}

function RandomPercentageDifference(value, percentMin, percentMax, notthisArray){
    var percent = GenerateRandom(percentMin, percentMax)/100;
    //generate value
    //plus or minus
    var rand = GenerateRandom(1,2);
    if (rand == 1){
        var randomValue = value + (value*percent);
    }else{
        var randomValue = value - (value*percent);
    }
    randomValue = Math.round(randomValue);
    if (notthisArray.includes(randomValue)){
        return RandomPercentageDifference(value,percentMin,percentMax,notthisArray);
    }
    
    return randomValue;
}

function GenerateRandom(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

function getAnswer(calculation) {
    const calculationParts = calculation;

    if (calculationParts.length === 3) {
        const [number1, operator, number2] = calculationParts;

        switch (operator) {
            case "÷":
                return number1 / number2;
            case "x":
                return number1 * number2;
            default:
                break;
        }
    } else if (calculationParts.length === 5) {
        let number1 = calculationParts[0];
        let number2 = calculationParts[2];
        let number3 = calculationParts[4];
        return number1 * number2 * number3;
    } else {
        return 0;
    }
}

function getWrongAnswer(correctAnswer, existingWrongAnswers) {
    var addOrSubtract = [0, 1];
    var output = 0;
    var getAnswer = true;

    do {
        var operatorSelection = Math.floor(Math.random() * addOrSubtract.length);
        var differenceSelection = Math.floor(Math.random() * 10);
        if (operatorSelection === 0) {
            output = correctAnswer - differenceSelection;
        } else {
            output = correctAnswer + differenceSelection;
        }

        if (
            existingWrongAnswers.includes(output) === false &&
            output !== correctAnswer &&
            output > 0
        ) {
            getAnswer = false;
        }
    } while (getAnswer === true);

    return output;
}

export default function Rating({ ...props }) {
    const game = useGame(props.game.id);
    const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
    const [levels, setLevels] = useState();

    // once the questions have been retrieved we then generate the questionlist for the rating game
    useEffect(() => {
        if (questions !== undefined) {
            let levelQs = [];
            questions.forEach((levelQuestions, i) => {
                var newLevelQuestions = [];
                levelQuestions.forEach(q => {
                    for (var i = 1; i < 12; i++) {
                        let generatedCalculation = [];
                        let calc = q.example_question.split(" ");

                        if (calc.length === 3) {
                            const number2 = parseInt(calc[2]);
                            const number1 = calc[1] === "÷" ? i * number2 : i;
                            generatedCalculation[0] = number1;
                            generatedCalculation[1] = calc[1];
                            generatedCalculation[2] = number2;
                        } else if (calc.length === 5) {
                            // if got length of 5 then we expect [number1 , operator, number2, operator, number3] (eg. a x b x c) and need to generate a random number for each part of the calulation
                            const number1 = Math.floor(Math.random() * 9 + 1);
                            const number2 = Math.floor(Math.random() * 9 + 1);
                            const number3 = Math.floor(Math.random() * 9 + 1);
                            const operator = "x";
                            generatedCalculation[0] = number1;
                            generatedCalculation[1] = operator;
                            generatedCalculation[2] = number2;
                            generatedCalculation[3] = operator;
                            generatedCalculation[4] = number3;
                        }
                        if (levelQs.topic_key == "multiple10") {//times by multiple of 10
                            let num1 = GenerateRandom(1, 99);
                            var num2array = [10, 100, 1000];
                            var num2 = num2array[GenerateRandom(0, num2array.length)];
                            const operator = "x";
                            //
                            generatedCalculation[0] = num1;
                            generatedCalculation[1] = operator;
                            generatedCalculation[2] = num2;
                        }
                        if (levelQs.topic_key == "multiple10+1") {//times by almost a multiple of 10
                            let num1 = GenerateRandom(1, 99);
                            var num2array = [9, 99, 999, 11, 101, 1001];
                            var num2 = num2array[GenerateRandom(0, num2array.length)];
                            const operator = "x";
                            //
                            generatedCalculation[0] = num1;
                            generatedCalculation[1] = operator;
                            generatedCalculation[2] = num2;
                        }
                        if (q.topic_key == "dec") {//times by decimal
                            //generate answer first and then work backwards
                            var num2array = [10, 100, 1000];
                            var num2 = num2array[GenerateRandom(0, num2array.length)];
                            let ans = 0;
                            if (num2 == 10) {
                                ans = GenerateRandom(1, 10)
                            }
                            if (num2 == 100) {
                                ans = GenerateRandom(11, 100)
                            }
                            if (num2 == 1000) {
                                ans = GenerateRandom(101, 1000)
                            }
                            let num1 = ans / num2;
                            const operator = "x";
                            //
                            generatedCalculation[0] = num1;
                            generatedCalculation[1] = operator;
                            generatedCalculation[2] = num2;
                            ans = Math.trunc(ans);
                        }
                        if (q.topic_key == "cubes") {//cube a number
                            var override = "cubes";
                            var num1 = GenerateRandom(2, 10);
                            const operator = "^";
                            //
                            generatedCalculation[0] = num1;
                            generatedCalculation[1] = "³";
                            var ans = num1 * num1 * num1;
                        }
                        if (q.topic_key == "multorder"){//multiplication order
                            var override = "multorder";
                            var num1 = GenerateRandom(2,10);
                            var num2 = GenerateRandom(2,10);
                            var num3 = GenerateRandom(1,num2);
                            //
                            generatedCalculation[0] = num1;
                            generatedCalculation[1] = "x";
                            generatedCalculation[2] = "(";
                            generatedCalculation[3] = num2;
                            generatedCalculation[4] = "-";
                            generatedCalculation[5] = num3;
                            generatedCalculation[6] = ")";
                            var ans = num1*(num2-num3);
                        }
                        if (q.topic_key == "divorder"){//multiplication order
                            var override = "divorder";
                            var ans = GenerateRandom(1,10);
                            var num1 = GenerateRandom(2,10);
                            var num2 = GenerateRandom(1,num1);
                            var num3 = ans * (num1 - num2);
                            //
                            generatedCalculation[0] = num3;
                            generatedCalculation[1] = "÷";
                            generatedCalculation[2] = "(";
                            generatedCalculation[3] = num1;
                            generatedCalculation[4] = "-";
                            generatedCalculation[5] = num2;
                            generatedCalculation[6] = ")";
                        }
                        if (q.topic_key == "squares"){//square a number
                            var override = "squares";
                            var num1 = GenerateRandom(2,10);
                            const operator = "^";
                            //
                            generatedCalculation[0] = num1;
                            generatedCalculation[1] = "²";
                            var ans = num1*num1;
                        }
                        if (q.topic_key == "squares2"){//cube a number
                            var override = "squares2";
                            var num1 = GenerateRandom(1,10);
                            var num2 = GenerateRandom(1,9);
                            var ans = (num1*num1) + num2;
                            //
                            generatedCalculation[0] = num1;
                            generatedCalculation[1] = "²";
                            generatedCalculation[2] = "+";
                            generatedCalculation[3] = num2;
                            
                        }
                        if (q.topic_key == "div"){//advanced div
                            var num1 = GenerateRandom(1,10);
                            var num2 = GenerateRandom(1,10)*num1*10;
                            var ans = num2/num1;
                            //
                            generatedCalculation[0] = num2;
                            generatedCalculation[1] = "÷";
                            generatedCalculation[2] = num1;
                        }
                         //new questions here
                    if(q.topic_key == "count2")
                    {
                        var override = "counting";
                        var extraNumbers = "";
                        var num1array = [2,4,6,8,10,12,14,16];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 2;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 2s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(q.topic_key == "count3")
                    {
                        var override = "counting";
                        var extraNumbers = "";
                        var num1array = [3,6,9,12,15,18,21,24];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 3;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 3s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(q.topic_key == "count4")
                    {
                        var override = "counting";
                        var extraNumbers = "";
                        var num1array = [4,8,12,16,20,24,28,32];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 4;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 4s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(q.topic_key == "count5")
                    {
                        var override = "counting";
                        var extraNumbers = "";
                        var num1array = [5,10,15,20,25,30,35,40];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 5;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 5s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(q.topic_key == "count6")
                    {
                        var override = "counting";
                        var extraNumbers = "";
                        var num1array = [6,12,18,24,30,36,42,48];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 6;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 6s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(q.topic_key == "count7")
                    {
                        var override = "counting";
                        var extraNumbers = "";
                        var num1array = [7,14,21,28,35,42,49,56];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 7;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 7s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(q.topic_key == "count8")
                    {
                        var override = "counting";
                        var extraNumbers = "";
                        var num1array = [8,16,24,32,40,48,56,64];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 8;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 8s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(q.topic_key == "count9")
                    {
                        var override = "counting";
                        var extraNumbers = "";
                        var num1array = [9,18,27,36,45,54,63,72];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 9;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 9s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(q.topic_key == "count10")
                    {
                        var override = "counting";
                        var extraNumbers = "";
                        var num1array = [10,20,30,40,50,60,70,80];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 10;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 10s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";

                        console.log(q);

                    }
                        let questionText = generatedCalculation.join(" ");
                        let questionAnswers = [];
                        if (override == undefined) {
                            let correctAnswer = getAnswer(generatedCalculation);
                            let wrongAnswers = [];
                            questionAnswers.push({
                                correct: true,
                                value: getAnswer(generatedCalculation)
                            });
                            for (var n = 1; n < 4; n++) {
                                var newIncorrectAnswer = getWrongAnswer(
                                    correctAnswer,
                                    wrongAnswers
                                );
                                wrongAnswers.push(newIncorrectAnswer);
                                questionAnswers.push({
                                    correct: false,
                                    value: newIncorrectAnswer
                                });
                            }
                        }else{
                            let correctAnswer = ans;
                            let wrongAnswers = [];
                            let usedAnswers = [];
                            questionAnswers.push({
                                correct: true,
                                value: ans
                            })
                            console.log(generatedCalculation);
                            console.log(q.topic_key);
                            usedAnswers.push(ans);
                            for (var n = 1; n < 4; n++) {
                                if (ans == 1){
                                    var newIncorrectAnswer = 1 + GenerateRandom(1,5);
                                }else{
                                    var newIncorrectAnswer = RandomPercentageDifference(ans,25,150,usedAnswers) //plus or minus up to 15%
                                }
                                wrongAnswers.push(newIncorrectAnswer);
                                usedAnswers.push(newIncorrectAnswer);
                                questionAnswers.push({
                                    correct: false,
                                    value: newIncorrectAnswer
                                });
                            }
                        }
                        

                        shuffleArray(questionAnswers);

                        let questionObj = {
                            question: questionText,
                            answers: questionAnswers,
                            topic_id: q.topic_id
                        };

                        newLevelQuestions.push(questionObj);
                    }
                });
                shuffleArray(newLevelQuestions);
                levelQs[i] = newLevelQuestions;
            });
            setLevels(levelQs);
        }
    }, [questions]);

    return levels !== undefined ? (
        <RatingGame
            questionslist={levels}
            onBack={() => {
                navigate(`/games/${game.id}`);
            }}
            game={game}
            endless={props.endless}
            initialLevel={props.initialLevel}
        />
    ) : (
            <LoadingScreen />
        );
}
